export const environment = {
  production: false,
  apiBaseUrl: 'https://bg-imports-api-server-staging-982203785653.us-east4.run.app',
};
